import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceinpune() {



  const cardData = {


  keyword: "Cheapest Cab Service in Pune",

  headingDescription: "Trustline Travels offers one of the cheapest cab services in Pune with safe, comfortable, and budget-friendly taxi solutions for local travel, airport transfers, railway station transfers, corporate transportation, sightseeing, and outstation journeys. Whether you need an economical one-way cab, round-trip taxi, or full-day car rental, our experienced chauffeurs ensure a smooth and hassle-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles to suit every budget and travel requirement. With transparent pricing, no hidden charges, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is the trusted choice for affordable cab services in Pune and outstation travel across Maharashtra and India.",

  topPlaces: [
    {
      title: "Lonavala",
      description: "Lonavala is a popular hill station near Pune, famous for its scenic valleys, waterfalls, Tiger Point, Bhushi Dam, and pleasant weather throughout the year."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is one of Maharashtra's most loved hill stations, offering strawberry farms, breathtaking viewpoints, Venna Lake, and cool mountain weather."
    },
    {
      title: "Shirdi",
      description: "Shirdi is a renowned pilgrimage destination where millions of devotees visit the sacred Shri Sai Baba Temple for spiritual blessings every year."
    },
    {
      title: "Mumbai",
      description: "Mumbai is India's financial capital, offering world-class business districts, iconic landmarks, entertainment, shopping, and coastal attractions."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a beautiful beach destination known for its clean coastline, sea forts, water sports, and relaxing weekend getaways."
    },
    {
      title: "Nashik",
      description: "Nashik is famous for its vineyards, wineries, ancient temples, and the sacred Godavari River, making it ideal for leisure and spiritual travel."
    },
    {
      title: "Goa",
      description: "Goa is India's favorite holiday destination, offering beautiful beaches, vibrant nightlife, Portuguese heritage, water sports, and luxury resorts."
    },
    {
      title: "Kolhapur",
      description: "Kolhapur is well known for the Mahalakshmi Temple, historic forts, delicious cuisine, and rich cultural traditions."
    },
    {
      title: "Aurangabad",
      description: "Aurangabad is home to the world-famous Ajanta and Ellora Caves, Bibi Ka Maqbara, and several important historical monuments."
    },
    {
      title: "Matheran",
      description: "Matheran is Asia's only automobile-free hill station, offering scenic viewpoints, toy train rides, lush forests, and a peaceful atmosphere."
    }
  ],






"services": [
{
"name": "Cheapest Taxi Service in Pune",
"description": "Book the cheapest taxi service in Pune for local travel, airport transfers, railway station pickup, corporate travel, family outings, and outstation trips. Enjoy affordable fares, professional drivers, clean AC vehicles, transparent pricing, instant booking, and 24x7 taxi service with Sedan, Ertiga, Innova Crysta, and SUV options."
},
{
"name": "Cheapest Cab Service in Pimpri Chinchwad",
"description": "Hire the cheapest cab service in Pimpri Chinchwad for local rides, airport transfers, Pune to Mumbai travel, and outstation tours. Get reliable drivers, sanitized vehicles, affordable pricing, doorstep pickup, and comfortable travel with instant booking confirmation."
},
{
"name": "Cheapest Cab Service in Hinjewadi",
"description": "Choose the cheapest cab service in Hinjewadi for IT professionals, airport pickups, office travel, corporate transportation, and outstation journeys. Book Sedan, Ertiga, Innova Crysta, and SUV cabs with experienced chauffeurs and competitive fares."
},
{
"name": "Cheapest Cab Service in Baner",
"description": "Book the cheapest cab service in Baner for airport transfers, business travel, local city rides, Mumbai airport drops, and family trips with clean AC cars, professional drivers, and transparent pricing."
},
{
"name": "Cheapest Cab Service in Wakad",
"description": "Reliable cheapest cab service in Wakad for local taxi booking, Pune Airport transfers, Mumbai travel, and outstation cab services with affordable fares, experienced drivers, and comfortable vehicles."
},
{
"name": "Cheapest Cab Service in Kharadi",
"description": "Hire the cheapest cab service in Kharadi for airport transportation, corporate travel, railway station pickup, and long-distance trips with premium AC vehicles, punctual drivers, and budget-friendly pricing."
},
{
"name": "Cheapest Cab Service in Hadapsar",
"description": "Book the cheapest cab service in Hadapsar for local travel, airport cabs, Mumbai transfers, business travel, and outstation tours with safe, reliable, and chauffeur-driven vehicles at economical rates."
},
{
"name": "Cheapest Cab Service in Viman Nagar",
"description": "Choose the cheapest cab service in Viman Nagar for Pune Airport transfers, corporate travel, local rides, and outstation taxi booking with affordable fares, professional drivers, and comfortable AC vehicles."
},
{
"name": "Cheapest Cab Service in Kothrud",
"description": "Book the cheapest cab service in Kothrud for airport transfers, city rides, family outings, and outstation travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles available at competitive prices."
},
{
"name": "Cheapest Cab Service in Shivajinagar",
"description": "Hire the cheapest cab service in Shivajinagar for railway station pickup, airport drop, local travel, and outstation journeys with experienced chauffeurs, clean vehicles, and transparent pricing."
},
{
"name": "Cheapest Cab Service in Nigdi",
"description": "Reliable cheapest cab service in Nigdi offering affordable local taxi services, airport transportation, Pune to Mumbai cabs, and outstation travel with well-maintained vehicles and verified drivers."
},
{
"name": "Cheapest Cab Service in Chinchwad",
"description": "Book the cheapest cab service in Chinchwad for airport pickups, business travel, family trips, and one-way or round-trip outstation journeys with affordable pricing and dependable service."
},
{
"name": "Cheapest Cab Service in Bhosari",
"description": "Choose the cheapest cab service in Bhosari for industrial visits, airport transfers, railway station pickups, corporate travel, and outstation tours with clean AC vehicles and experienced chauffeurs."
},
{
"name": "Cheapest Cab Service in Aundh",
"description": "Hire the cheapest cab service in Aundh for local transportation, airport cabs, business travel, and family outings with budget-friendly fares, professional drivers, and comfortable cars."
},
{
"name": "Cheapest Cab Service in Bavdhan",
"description": "Book the cheapest cab service in Bavdhan for local taxi rides, Pune Airport transfers, Mumbai trips, and outstation travel with safe, affordable, and chauffeur-driven vehicles."
},
{
"name": "Cheapest Cab Service in Wagholi",
"description": "Choose the cheapest cab service in Wagholi for airport transfers, Pune to Mumbai travel, family vacations, corporate transportation, and outstation taxi services with affordable pricing and reliable drivers."
},
{
"name": "Pune to Mumbai Cheap Cab",
"description": "Book Pune to Mumbai cheap cab with affordable one-way and round-trip fares, clean AC vehicles, experienced drivers, doorstep pickup, and flexible travel options including Sedan, Ertiga, Innova Crysta, and SUVs."
},
{
"name": "Pune to Mumbai Airport Cab",
"description": "Hire Pune to Mumbai Airport cab for timely airport pickup and drop with flight tracking, spacious luggage space, professional chauffeurs, and comfortable long-distance travel available 24x7."
},
{
"name": "Book Cheapest Cab in Pune",
"description": "Book the cheapest cab in Pune online with instant confirmation, transparent pricing, multiple vehicle options, experienced drivers, and dependable taxi services for local and outstation travel."
},
{
"name": "Hire Cab in Pune",
"description": "Hire cab in Pune for airport transfers, railway station pickup, local city rides, business travel, sightseeing tours, and outstation trips with clean AC cars and courteous professional drivers."
},
{
"name": "Cheapest Cab Service in Pune",
"description": "Book the cheapest cab service in Pune with affordable fares, well-maintained Sedan, Ertiga, Innova Crysta, and SUV vehicles for local travel, airport transfers, corporate travel, family tours, and outstation journeys."
},
{
"name": "Affordable Cab Service Pune",
"description": "Choose affordable cab service Pune for reliable transportation with budget-friendly pricing, verified drivers, transparent fares, clean vehicles, and convenient booking for local and long-distance travel."
},
{
"name": "Cheap Cab Booking Pune",
"description": "Book cheap cab booking Pune with instant online confirmation, affordable taxi rates, multiple vehicle categories, and dependable chauffeur-driven services for airport, city, and outstation travel."
},
{
"name": "Taxi Service in Pune",
"description": "Reliable taxi service in Pune offering local travel, airport pickup and drop, railway station transfers, corporate transportation, sightseeing tours, and outstation taxi services with professional drivers and AC vehicles."
},
{
"name": "Outstation Cab Service Pune",
"description": "Book outstation cab service Pune for comfortable trips to Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, Aurangabad, and other destinations with one-way and round-trip taxi options."
},
{
"name": "Pune Airport Cab Service",
"description": "Choose Pune Airport cab service for reliable airport transfers with timely pickup, flight monitoring, spacious luggage capacity, experienced chauffeurs, and comfortable AC vehicles available 24x7."
},
{
"name": "Online Cab Booking Pune",
"description": "Book online cab booking Pune with instant confirmation, transparent pricing, secure reservations, and a wide fleet of Sedan, Ertiga, Innova Crysta, and SUV vehicles for every travel requirement."
},
{
"name": "Cab Service Near Me",
"description": "Find trusted cab service near me with reliable drivers, affordable fares, local taxi booking, airport transfers, corporate transportation, and outstation travel available anytime with easy online booking."
},
{
"name": "Best Cab Service in Pune",
"description": "Choose the best cab service in Pune for premium travel experience with clean AC vehicles, verified drivers, affordable pricing, punctual pickups, and reliable local, airport, and outstation taxi services."
},
{
"name": "Pune to Mumbai Cab",
"description": "Book Pune to Mumbai cab for one-way, round-trip, airport transfers, corporate travel, family tours, and weekend trips with Sedan, Ertiga, Innova Crysta, and SUV vehicles offering safe, comfortable, and affordable travel."
}
],

"tableData": [
["Cheapest Taxi Service in Pune", "Cheapest Cab Service in Pimpri Chinchwad"],
["Cheapest Cab Service in Hinjewadi", "Cheapest Cab Service in Baner"],
["Cheapest Cab Service in Wakad", "Cheapest Cab Service in Kharadi"],
["Cheapest Cab Service in Hadapsar", "Cheapest Cab Service in Viman Nagar"],
["Cheapest Cab Service in Kothrud", "Cheapest Cab Service in Shivajinagar"],
["Cheapest Cab Service in Nigdi", "Cheapest Cab Service in Chinchwad"],
["Cheapest Cab Service in Bhosari", "Cheapest Cab Service in Aundh"],
["Cheapest Cab Service in Bavdhan", "Cheapest Cab Service in Wagholi"],
["Pune to Mumbai Cheap Cab", "Pune to Mumbai Airport Cab"],
["Book Cheapest Cab in Pune", "Hire Cab in Pune"],
["Cheapest Cab Service in Pune", "Affordable Cab Service Pune"],
["Cheap Cab Booking Pune", "Taxi Service in Pune"],
["Outstation Cab Service Pune", "Pune Airport Cab Service"],
["Online Cab Booking Pune", "Cab Service Near Me"],
["Best Cab Service in Pune", "Pune to Mumbai Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Cheapest Cab Service in Pune",
    WhyChoosedescription: "Trustline Travels offers budget-friendly cab services in Pune without compromising on comfort, safety, or service quality."
  },
  {
    WhyChooseheading: "Transparent & Fixed Cab Pricing",
    WhyChoosedescription: "Enjoy affordable fares with clear pricing, detailed quotations, and no hidden charges for local and outstation travel."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Budget",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to match your travel needs and budget."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Book a cab anytime for local rides, airport transfers, corporate travel, or outstation trips with round-the-clock service."
  },
  {
    WhyChooseheading: "Experienced & Verified Drivers",
    WhyChoosedescription: "Our professional drivers ensure safe, punctual, and comfortable journeys across Pune and nearby destinations."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "We provide economical one-way cabs, return journeys, and customized travel packages at competitive prices."
  },
  {
    WhyChooseheading: "Perfect for Airport & Outstation Travel",
    WhyChoosedescription: "Book affordable cabs for Pune Airport, Mumbai Airport, business travel, sightseeing, and outstation destinations."
  },
  {
    WhyChooseheading: "Fast Booking & Instant Confirmation",
    WhyChoosedescription: "Receive quick fare quotations, easy booking assistance, and instant confirmation from our dedicated support team."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide the cheapest cab service in Pune?",
    answer: "Yes, Trustline Travels offers affordable cab services in Pune with transparent pricing for local, airport, and outstation travel."
  },
  {
    question: "Can I book a low-cost one-way cab in Pune?",
    answer: "Yes, we provide budget-friendly one-way cab services to various destinations from Pune."
  },
  {
    question: "Which vehicles are available for affordable cab booking?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit different budgets and travel requirements."
  },
  {
    question: "Do you provide airport cab services at affordable rates?",
    answer: "Yes, we offer economical airport pickup and drop services for Pune Airport and Mumbai Airport."
  },
  {
    question: "Are there any hidden charges in your cab fare?",
    answer: "No, Trustline Travels follows transparent pricing with clear fare details before confirming your booking."
  },
  {
    question: "Do you provide local and outstation cab services?",
    answer: "Yes, we offer affordable local taxi services, corporate travel, sightseeing, and outstation cab bookings from Pune."
  },
  {
    question: "Is cab service available 24 hours in Pune?",
    answer: "Yes, our cab services are available 24/7 for airport transfers, local rides, and outstation travel."
  },
  {
    question: "Can I book a cab in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and travel schedule."
  },
  {
    question: "Are your drivers experienced and verified?",
    answer: "Yes, all our drivers are experienced, verified, and committed to providing safe and comfortable travel."
  },
  {
    question: "How can I book the cheapest cab service in Pune with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Kulkarni",
    feedback: "Finding an affordable cab in Pune was easy with Trustline Travels. The fare was reasonable, the vehicle was clean, and the entire journey was comfortable and professionally managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neeta Sharma",
    feedback: "Trustline Travels offered one of the best budget-friendly cab services we have used in Pune. The booking process was simple, the driver arrived on time, and the service exceeded our expectations.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/cheapest-cab-service-in-pune.webp",
  "description": "Book the cheapest cab service in Pune with Trustline Travels for affordable and reliable travel. Get budget-friendly local, airport, one-way, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6821"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/cheapest-cab-service-in-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Cheapest Cab Service in Pune | Affordable Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book the cheapest cab service in Pune with Trustline Travels. Enjoy affordable taxi services in Pune, Pimpri Chinchwad, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, and other areas with 24x7 cab availability."
  />

  <meta
    name="keywords"
    content="cheapest taxi service in pune, Cheapest Cab Service in Pimpri Chinchwad, Cheapest Cab Service in Hinjewadi, Cheapest Cab Service in Baner, Cheapest Cab Service in Wakad, Cheapest Cab Service in Kharadi, Cheapest Cab Service in Hadapsar, Cheapest Cab Service in Pune, affordable cab service pune, cheap taxi booking pune, low fare taxi pune, budget cab service pune, online cab booking pune, pune airport taxi service, pune outstation cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cheapestcabserviceinpune;